<template>
  <form @submit.prevent="submit" class="email-form">
    <Field
      placeholder="new-email-address@company.com"
      @input="$v.resource.email_reset_to.$touch()"
      v-model="resource.email_reset_to"
      :error="email_reset_toError"
    />

    <div class="centered">
      <button class="btn is-tertiary">Change</button>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import {errorMessages} from '@/lib/error_messages'
import {required, email} from 'vuelidate/lib/validators'

export default {
  name: 'email-form',

  mixins: [form],

  computed: {
    ...errorMessages(['email_reset_to'])
  },

  validations: {
    resource: {
      email_reset_to: {required, email}
    }
  }
}
</script>

<style lang="sass">
.email-form
</style>
